<template>
	<div class="addonetether-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_jpys_page_v2.sec_10.title.one') }}
					<br />
					{{ $t('new_ui.personal_jpys_page_v2.sec_10.title.two') }}
				</h2>
				<p>
					{{ $t('new_ui.personal_jpys_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.personal_jpys_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/login" class="btn-type-01">
						{{ $t('new_ui.personal_jpys_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_jpys_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img :src="img.imgAddonetetherSec10" alt="" />
				</div>
			</div>
		</section>

		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_jpys_page_v2.sec_04.title') }}
				</h3>
				<p class="desc">
					{{ $t('new_ui.personal_jpys_page_v2.sec_04.desc') }}
				</p>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t('new_ui.personal_jpys_page_v2.sec_04.cards.one.title.one')
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_jpys_page_v2.sec_04.cards.one.description.one',
									)
								}}
							</p>
						</div>
						<img :src="img.iconAddonetether01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t('new_ui.personal_jpys_page_v2.sec_04.cards.two.title.one')
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_jpys_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_jpys_page_v2.sec_04.cards.two.description.two',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_jpys_page_v2.sec_04.cards.two.description.three',
									)
								}}
							</p>
						</div>
						<img :src="img.iconAddonetether02" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgAddonetetherSec10 from '@/assets/images/v2/img-addonetether-sec-10.png';
import iconAddonetether01 from '@/assets/images/v2/icon/icon-addonetether-01.svg';
import iconAddonetether02 from '@/assets/images/v2/icon/icon-addonetether-02.svg';

export default {
	data: () => {
		return {
			img: {
				imgAddonetetherSec10,
				iconAddonetether01,
				iconAddonetether02,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
